import React from 'react';
import ReactDOM from 'react-dom';



window.location.assign("https://genericbells.pages.dev/");